import { ModelBase } from 'store/model-base';

export class RetryPaymentData extends ModelBase {
    public static storeName: string = 'retryPaymentData';

    public isUsingNewCard: boolean;
    public isUsingSameAddress: boolean;
    public userData: RetryPaymentNewCardInfo;
    public ccType: string;
    public ccLastFour: string;
    public amount: number;
    public isUsingSameAmount: boolean;
}
